import { ProductCard, ProductCardProps } from '.';

export const ProductCardDish = (props: ProductCardProps) => {
  return <ProductCard {...props} />;
};
